module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee61d751caff48918c0a.worker.js");
};